import { Injectable } from '@angular/core';
export const locked = "These fields are currently locked, pending review and approval.";

function sanitizeEditorContent(content: string): string {
  if (!content) {
    return content;
  }
  return content.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g, '');
}

@Injectable()
export class appCommonConstant {
    defaultTemplateCategoryId= 1;
    articleTemplateCategoryId= 2;
    programTemplateCategoryId= 3;
    degreeLevelLinked= 1;
    degreeLevelNotLinked= 0;
    pagenationCount= 10;
    isRecordLockedMessage= 'These fields are currently locked; pending review and approval.';
    academicYearRange= 10;
    copyYearRange= 20;
    academicYearOffset= 0;
    is_acc_open=false;
    is_dirty_check= false;
    createTemplateShellFlag = 1;
    tinySettings={
      selector: 'textarea',
      automatic_uploads: true,
      forced_root_block: "",
      force_br_newlines: true,
      force_p_newlines: false,
      convert_urls: false,
      entity_encoding: "numeric",
      file_picker_types: 'image',
      extended_valid_elements: "",
      paste_as_text: false,
      paste_data_images: true,
      powerpaste_allow_local_images: true,
      paste_preprocess: function (_plugin, args) {
        if (args && args.content) {
          args.content = sanitizeEditorContent(args.content);
        }
      },
      valid_elements: "@[id|title|dir<ltr?rtl|lang|xml::lang|*],"
      + "a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
      + "name|href|target|title|class|*],strong/b[id],em/i[*],strike,u,"
      + "p[id],ol[type|compact|*],ul[type|compact|*],li,br[*],img[longdesc|usemap|"
      + "src|border|alt=|title|hspace|vspace|width|height|align|*],sub[*],sup[*],"
      + "blockquote[*],table[border=0|cellspacing|cellpadding|width|frame|rules|"
      + "height|align|summary|bgcolor|background|bordercolor|*],tr[rowspan|width|"
      + "height|align|valign|bgcolor|background|bordercolor|*],tbody,thead,tfoot,"
      + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
      + "|scope|*],#th[colspan|rowspan|width|height|align|valign|scope|*],caption[*],div[*],"
      + "span[id],code,pre,address,h1[*],h2[*],h3[*],h4[*],h5[*],h6[*],hr[size|noshade|*],font[face"
      + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
      + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
      + "|height|src|*],map[name],area[shape|coords|href|alt|target],bdo,"
      + "button[*],col[align|char|charoff|valign|width],colgroup[align|char|charoff|"
      + "valign|width|*],dfn,fieldset,form[action|accept|accept-charset|enctype|method|*],"
      + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value|*],"
      + "kbd,label[for|*],legend,noscript,optgroup[label|disabled|*],option[disabled|label|selected|value|*],"
      + "q[cite],samp,select[disabled|multiple|name|size|*],small,"
      + "textarea[cols|rows|disabled|name|readonly|*],tt,var,big,"
      + "iframe[src|allowtransparency|frameborder|scrolling|class|name|allowfullscreen |mozallowfullscreen |webkitallowfullscreen |oallowfullscreen |msallowfullscreen |width|height|*],"
      + "script[type|src|*],time[*],nav[*],header[*],footer[*],link[*]",
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
        'insertdatetime', 'media', 'table', 'help', 'wordcount'
      ],
      toolbar: 'aligncenter alignjustify alignleft alignright | blockquote blocks | bold italic underline | print | dynamicData | fontfamily fontsize forecolor backcolor indent outdent | language | lineheight | redo undo | styles | a11ycheck advtablerownumbering typopgraphy anchor restoredraft casechange charmap checklist code codesample addcomment showcomments ltr rtl editimage fliph flipv imageoptions rotateleft rotateright emoticons export footnotes footnotesupdate formatpainter fullscreen image insertdatetime link openlink unlink bullist numlist media mergetags mergetags_list nonbreaking pagebreak pageembed permanentpen preview quickimage quicklink quicktable cancel save searchreplace spellcheckdialog spellchecker | table | template typography | insertfile | visualblocks visualchars',
      advlist_bullet_styles: "square",
      advlist_number_styles: 'lower-alpha,lower-roman,upper-alpha,upper-roman',
      'theme_advanced_source_editor_height': "500",
      'theme_advanced_source_editor_width': "720",
      setup: function (editor) {
        this.editor = editor;  
        editor.on('BeforeSetContent', function (event) {
          if (event && event.content) {
            event.content = sanitizeEditorContent(event.content);
          }
        });
        editor.ui.registry.addButton('dynamicData', {
          text: 'Dynamic Data',
          onAction: function () {
            editor.windowManager.open({
              title: '',
              body: {
                type: 'panel',
                items: [ {
                  type: 'checkbox',
                  name: 'UnivFullName',
                  label: 'University Full Name'
                }, {
                  type: 'checkbox',
                  name: 'UnivAccShortName',
                  label: 'University Acceptable ShortForm Name'
                }, {
                  type: 'checkbox',
                  name: 'UnivAccAbb',
                  label: 'University Acceptable Abbreviation'
                }, {
                  type: 'checkbox',
                  name: 'APUniversityPhNumber',
                  label: 'APUniversity Phone Number'
                }, {
                  type: 'checkbox',
                  name: 'PartnerCollegeName',
                  label: 'Partner College Name'
                }, {
                  type: 'checkbox',
                  name: 'ProgramFullName',
                  label: 'Program Full Name'
                }, {
                  type: 'checkbox',
                  name: 'ProgramAccShortName',
                  label: 'Program Acceptable ShortForm Name'
                }, {
                  type: 'checkbox',
                  name: 'ProgramAccAbbreviation',
                  label: 'Program Acceptable Abbreviation'
                }, {
                  type: 'checkbox',
                  name: 'ProgramDuration',
                  label: 'Program Duration'
                }, {
                  type: 'checkbox',
                  name: 'ProgramCreditHours',
                  label: 'Program Credit Hours'
                }, {
                  type: 'checkbox',
                  name: 'NextStartDate',
                  label: 'Next Start Date'
                }, {
                  type: 'checkbox',
                  name: 'NextApplnDedLine',
                  label: 'Next Application Deadline'
                }, {
                  type: 'checkbox',
                  name: 'PerCreditHours',
                  label: 'Per Credit Hour Tuition'
                }, {
                  type: 'checkbox',
                  name: 'PerCourseTuition',
                  label: 'Per Course Tuition'
                }, {
                  type: 'checkbox',
                  name: 'PerProgramTuition',
                  label: 'Per Program Tuition'
                }             
              ]
              },
              initialData: {
                UnivFullName: false,
                UnivAccShortName:false,
                UnivAccAbb:false
              },
              buttons: [
                {
                  type: 'cancel',
                  name: 'closeButton',
                  text: 'Cancel',
                  disabled: false,
                  primary: false,
                  align: 'start'
                },
                {
                  type: 'custom',
                  name: 'uniquename',
                  text: 'OK',
                  disabled: false, // button is active when the dialog opens
                  primary: true, // style the button as a primary button
                  align: 'start'
                }
              ],
              onAction: function (dialogApi, details) {
                var data = dialogApi.getData();
                console.log(data);
                var inputTagString = "";
                var selectedValues = [];
                
                if(data.UnivFullName)
                  selectedValues.push('University Full Name');
                if(data.UnivAccShortName)
                  selectedValues.push('University Acceptable ShortForm Name');
                if(data.UnivAccAbb)
                  selectedValues.push('University Acceptable Abbreviation');
                if(data.APUniversityPhNumber)
                  selectedValues.push('APUniversity Phone Number');
                if(data.PartnerCollegeName)
                  selectedValues.push('Partner College Name');
                if(data.ProgramFullName)
                  selectedValues.push('Program Full Name');
                if(data.ProgramAccShortName)
                  selectedValues.push('Program Acceptable ShortForm Name');
                if(data.ProgramAccAbbreviation)
                  selectedValues.push('Program Acceptable Abbreviation');
                if(data.ProgramDuration)
                  selectedValues.push('Program Duration');
                if(data.ProgramCreditHours)
                  selectedValues.push('Program Credit Hours');
                if(data.NextStartDate)
                  selectedValues.push('Next Start Date');
                if(data.NextApplnDedLine)
                  selectedValues.push('Next Application Deadline');
                if(data.PerCreditHours)
                  selectedValues.push('Per Credit Hour Tuition');
                if(data.PerCourseTuition)
                  selectedValues.push('Per Course Tuition');
                if(data.PerProgramTuition)
                  selectedValues.push('Per Program Tuition');
                
                for (const value of selectedValues) {
                  inputTagString += `<input value="${value}" name="custom_field__29541" type="text"  readonly style="background-color: #ffff33 !important; border: 1px solid black; text-align: left;padding-left:5px;background:none;font-size:1em;" size="25"/>`;
                }
                
                editor.insertContent(inputTagString);
                // editor.execCommand('mceInsertContent', false, inputTagString);
                dialogApi.close();
              }
            })
          }
        });
      },
      file_picker_callback: function (callback, value, meta) {
        if (meta.filetype == 'image') {
          var input = document.getElementById('my-file');
          input.click();
          input.onchange = function () {
            var filepath = "/Resources/APDigitalImages/" + JSON.parse(JSON.parse(sessionStorage.getItem('ngStorage-selectedPartner'))).InternalUniversityCode + "/";
              var file = (<HTMLInputElement>document.getElementById('my-file')).files[0];
              callback(filepath +file.name, { alt: file.name });
          };
        }
      },
    };
  static is_acc_open: boolean;
  static is_dirty_check: boolean;
  public source = 'partner';
  timepicker : any;
}
